export default __webpack_public_path__ + "static/media/stacked-cards.7aa7ff71.png";